// $( document ).ready(function() {
//   //wait until the last element (#checkout-step-shipping_method) being rendered
//   var existCondition = setInterval(function() {
//    if ($('#insta-feed').length) { 
//     clearInterval(existCondition);
//     runMyFunction2();
//    }
//   }, 200);

//   function runMyFunction2(){
//    console.log("Insta Alert");
// $('#insta-feed a').attr('aria-labelledby','a11y-new-window-external-message');
//   }
// }); 
$('.page-hero__title-wrapper h1').each(function(){
    if( $(this).text().trim() === '' )
        $(this).remove();
  });
  $('#panel-2 h4').each(function(){
    if( $(this).text().trim() === '' )
        $(this).remove();
  });
$('br').attr('aria-hidden','true');
$('ul.site-nav li.site-nav--has-dropdown > a').removeAttr('href');
$('ul.site-nav li.site-nav--has-dropdown > a').attr('role', 'button');

// $('ul.site-nav li.site-nav--has-dropdown > .site-nav__link--main').attr('aria-expanded', 'false');
// $(document).ready(function() {
//   $("li.site-nav--has-dropdown").click(function() {
//     const dropdown = $(this).find(".site-nav__link--main");
//     if (dropdown.attr("aria-expanded") === "false") {
//       // Dropdown is closed, open it
//       dropdown.attr("aria-expanded", "true");
//       $(this).addClass("active"); // Add active class
//       // Code to display the dropdown menu as needed
//     } else {
//       // Dropdown is open, close it
//       dropdown.attr("aria-expanded", "false");
//       $(this).removeClass("active"); // Remove active class
//       // Code to hide the dropdown menu as needed
//     }
//   });

//   // Jab dropdown ke bahar kuch focus ho, to active class hata do
//   $(document).focusin(function(event) {
//     if (!$(event.target).closest("li.site-nav--has-dropdown").length) {
//       $("li.site-nav--has-dropdown .site-nav__link--main").attr("aria-expanded", "false");
//       $("li.site-nav--has-dropdown").removeClass("active");
//       // Code to hide the dropdown menu as needed
//     }
//   });
$(".site-nav--has-dropdown .site-nav__link--main").click(function(event) {
  event.stopPropagation(); // Prevent the event from propagating to the parent li

  // Toggle 'active' class
  var parentLi = $(this).closest("li.site-nav--has-dropdown");
  var isExpanded = parentLi.hasClass("active");
  parentLi.toggleClass("active");

  // Toggle 'aria-expanded' attribute
  $(this).attr("aria-expanded", !isExpanded);

  // Toggle dropdown visibility
  if (!isExpanded) {
    // Code to show dropdown
    // $(this).next(".dropdown-content").slideDown();
  } else {
    // Code to hide dropdown
    // $(this).next(".dropdown-content").slideUp();
  }
});

// Close dropdown when a screen reader reads it
$(".site-nav--has-dropdown .site-nav__link--main").on("keydown", function(event) {
  if (event.keyCode === 13 || event.keyCode === 32) {
    // Enter or Space key pressed
    // Close the dropdown
    var parentLi = $(this).closest("li.site-nav--has-dropdown");
    parentLi.removeClass("active").attr("aria-expanded", "false");
    // Code to hide dropdown
    // parentLi.find(".dropdown-content").slideUp();
  }
});

// Close dropdown when focus is outside the dropdown
$(document).on("focusin", function(event) {
  var dropdowns = $("li.site-nav--has-dropdown.active");
  if (dropdowns.length > 0 && !$(event.target).closest(dropdowns).length) {
    dropdowns.removeClass("active").find(".site-nav__link--main").attr("aria-expanded", "false");
    // Code to hide dropdown
    // dropdowns.find(".dropdown-content").slideUp();
  }
});

// });


var intervalID = window.setInterval(myCallback, 50);
function myCallback() {
    var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
    if (textAreaCheck.length > 0) {
           jQuery(textAreaCheck).attr('aria-label', 'g-recaptcha-response');
           console.log(jQuery(textAreaCheck));
      clearInterval(intervalID);
    }
 }  

 ///////////////////////////////
 $(document).ready(function() {
  // Function to switch between tabs
  function switchTabs(tabId) {
      // Hide all tab panels
      $('[role="tabpanel"]').attr('hidden', true);
      // Mark all tabs as unselected
      $('[role="tab"]').attr('aria-selected', false);

      // Show the selected tab panel
      $('#' + tabId).removeAttr('hidden');
      // Mark the selected tab as selected
      $('[aria-controls="' + tabId + '"]').attr('aria-selected', true);
  }

  // Initial tab state
  switchTabs('panel-1');

  // Add click event handlers for the tabs
  $('[role="tab"]').click(function () {
      var tabId = $(this).attr('aria-controls');
      switchTabs(tabId);
  });
});
// Add active class to the current button (highlight it)
var header = document.getElementById("product-tabs");
var btns = header.getElementsByClassName("pro_style");
for (var i = 0; i < btns.length; i++) {
  btns[i].addEventListener("click", function() {
  var current = document.getElementsByClassName("active");
  current[0].className = current[0].className.replace(" active", "");
  this.className += " active";
  });
}
